import { useCallback } from 'react';
import { useVariable } from './useVariable';
export const useFunction = variable => {
  const functionRef = useVariable(variable);
  return useCallback((...args) => functionRef.current?.(...args), []);
};